"use strict";

import { onReady } from '../core/ready.js';

const MAX_ZOOM_STEPS = 2;
const variantPageSelector = '.variant-page';
const variantHeroImageSelector = '.variant-hero .variant-image';
const zoomInSelector = '.variant-image-zoom .zoom-in';
const zoomOutSelector = '.variant-image-zoom .zoom-out';

const parseBaseScale = (imageEl) => {
    if (!imageEl) return 1;
    const rawScale = getComputedStyle(imageEl).getPropertyValue('--variant-scale');
    const parsed = parseFloat(rawScale);
    return Number.isFinite(parsed) ? parsed : 1;
};

const applyScale = (imageEl, baseScale, step) => {
    if (!imageEl) return;
    const nextScale = baseScale + step;
    imageEl.style.setProperty('--variant-scale', nextScale);
};

const toggleButton = (btn, disabled) => {
    if (!btn) return;
    btn.disabled = disabled;
    btn.classList.toggle('disabled', disabled);
};

const updateButtonsState = (zoomInBtn, zoomOutBtn, step) => {
    toggleButton(zoomInBtn, step >= MAX_ZOOM_STEPS);
    toggleButton(zoomOutBtn, step <= 0);
};

const initVariantZoom = () => {
    const variantPage = document.querySelector(variantPageSelector);
    if (!variantPage) return;

    const variantImage = variantPage.querySelector(variantHeroImageSelector);
    const zoomInBtn = variantPage.querySelector(zoomInSelector);
    const zoomOutBtn = variantPage.querySelector(zoomOutSelector);

    if (!variantImage || !zoomInBtn || !zoomOutBtn) return;

    const baseScale = parseBaseScale(variantImage);
    let zoomStep = 0;

    const handleZoomIn = () => {
        if (zoomStep >= MAX_ZOOM_STEPS) return;
        zoomStep += 1;
        applyScale(variantImage, baseScale, zoomStep);
        updateButtonsState(zoomInBtn, zoomOutBtn, zoomStep);
    };

    const handleZoomOut = () => {
        if (zoomStep <= 0) return;
        zoomStep -= 1;
        applyScale(variantImage, baseScale, zoomStep);
        updateButtonsState(zoomInBtn, zoomOutBtn, zoomStep);
    };

    zoomInBtn.addEventListener('click', handleZoomIn);
    zoomOutBtn.addEventListener('click', handleZoomOut);
    updateButtonsState(zoomInBtn, zoomOutBtn, zoomStep);
};

onReady(() => {
    initVariantZoom();
});
